import React, { useCallback, useMemo, useState } from "react";
import { TextInput } from "react-native";
import { Address } from "./address";
import { KeyboardController } from "react-native-keyboard-controller";
import { AddressChooser, AddressChooserProps } from "./AddressChooser";
import BaseField, { BaseFieldProps } from "../BaseField";
import { PressableWithFocus } from "../PressableWithFocus";

export type AddressFieldProps = Omit<BaseFieldProps, "component" | "hasValue" | "value"> &
    Omit<AddressChooserProps, "onDismiss" | "visible"> & {
        value?: Address;
    };

export const AddressField = ({
    value,
    onSelect,
    disabled = false,
    label,
    placeholder,
    error,
    testID,
    asListAction,
    right,
    style,
    ref,
    ...props
}: AddressFieldProps & { ref?: React.Ref<TextInput> }) => {
    const [chooserVisible, setChooserVisible] = useState(false);

    const handleSelect = useCallback(
        (address: Address) => {
            setChooserVisible(false);
            onSelect?.(address);
        },
        [onSelect],
    );

    const valueLabel = useMemo(() => value?.formatted || "", [value]);

    return (
        <>
            <AddressChooser
                onDismiss={() => setChooserVisible(false)}
                visible={chooserVisible}
                initialValue={valueLabel}
                onSelect={handleSelect}
                {...props}
            />
            <BaseField
                label={label}
                placeholder={placeholder}
                value={valueLabel}
                right={right}
                disabled={disabled}
                error={error}
                asListAction={asListAction}
                testID={testID}
                isFocused={chooserVisible}
                asButton
                style={style}
                componentRef={ref}
                component={
                    <PressableWithFocus
                        disabled={disabled}
                        onPress={() => {
                            if (KeyboardController.isVisible()) {
                                void KeyboardController.dismiss();
                            }
                            setChooserVisible(true);
                        }}
                    />
                }
            />
        </>
    );
};

export default AddressField;
